import type { MonitorConfig } from '@kmi/kmijs';
import { commonPVMap } from 'utils/pvurlmap';
import urlParse from 'url';

export const monitorConfig: MonitorConfig = {
    // 返回 true 表示上传
    autoPVFilter: (currentUrl, prevUrl, type) => {
        const { pathname } = urlParse.parse(String(currentUrl), true);
        // 当前 url，前一个 url，pv 子类型 enter|leave|hidden|visible
        if (pathname === '/population' || pathname === '/market/my_population') {
            return false; // false 表示不上报
        }
        return true; // true 表示上报
    },
    // weblogger 配置，分别对应第一个和第二个参数
    weblogger: {
        logConfig: {
            // WeblogInitParams[0]
            urlMap: commonPVMap,
        },
    },
};
